The identifier for the updated `PositionProfile`.
